import { axios } from '../../../lib/axios';

export const loginWithEmailAndPassword = (data) => {
  return axios.post('recaptcha_login', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
